import { GetStaticPropsResult } from 'next'

import { SanitySiteFragment } from '@data/sanity/queries/types/site'
import { SanitySignupPage } from '@data/sanity/queries/types/page'
import { getPreview } from '@lib/sanity/client'
import { getSignupPage } from '@lib/sanity/page'
import { Locale } from '@lib/language'
import { CustomStaticPropsContext } from '@lib/routes'

import Modules from '@modules/modules'
import Layout from '@components/layout'

interface SignupPageProps {
  locale: Locale
  page: SanitySignupPage
  site: SanitySiteFragment
}

const SignupPage = ({ page, site }: SignupPageProps) => (
  <Layout page={page} site={site}>
    <Modules modules={page.modules} />
  </Layout>
)

export async function getStaticProps({
  locale,
  preview,
  previewData,
}: CustomStaticPropsContext): Promise<GetStaticPropsResult<SignupPageProps>> {
  const signupPage = await getSignupPage(
    locale,
    getPreview(preview, previewData),
  )

  if (!signupPage.page) {
    return { notFound: true }
  }

  return {
    props: {
      locale,
      page: signupPage.page,
      site: signupPage.site,
    },
    revalidate: 60,
  }
}

export default SignupPage
